import { createI18n } from "vue-i18n";


import enMsg from "./locale/en.json";
import viMsg from "./locale/vi.json";
export const i18n = createI18n({
    legacy: false,
    locale:  localStorage.getItem("lang")||sessionStorage.getItem("lang")||"en",
    globalInjection: true,
    messages: {
      en: {
        message: enMsg
      },
      vi: {
        message: viMsg
      }
    }
  });